import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithButtons } from '../../../../components/designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppSwitch from '../../../../components/designe/app-switch/AppSwitch';
import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { useUnsavedChangesGuard } from '../../../../hooks/useUnsavedChangesGuard';
import { Paths } from '../../../../shared/paths';
import { useStyles } from './NotificationsEdit.styles';
import { useNotificationsEditComponent } from './useNotificationsEditComponent';

export default function NotificationsEdit() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { replace } = useNavigationStack();
  const {
    systemPush,
    setSystemPush,
    socialPush,
    setSocialPush,
    marketingPush,
    setMarketingPush,
    remindersPush,
    setRemindersPush,
    handleSave,
    isLoading,
    isDirty,
  } = useNotificationsEditComponent();
  const { allowAndLeave, dialog } = useUnsavedChangesGuard({
    isDirty,
    leaveAction: () => replace(Paths.settings.toNotificationsView),
  });

  return (
    <div className={classes.wrapper}>
      {dialog}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
        }}
        className={classes.content}>
        <Box className={classes.themeRow}>
          <Typography variant="text-md">
            {t('settings.notifications.system')}
          </Typography>
          <AppSwitch
            value={systemPush}
            onChange={() => setSystemPush(!systemPush)}
          />
        </Box>
        <Box className={classes.themeRow}>
          <Typography variant="text-md">
            {t('settings.notifications.social')}
          </Typography>
          <AppSwitch
            value={socialPush}
            onChange={() => setSocialPush(!socialPush)}
          />
        </Box>
        <Box className={classes.themeRow}>
          <Typography variant="text-md">
            {t('settings.notifications.marketing')}
          </Typography>
          <AppSwitch
            value={marketingPush}
            onChange={() => setMarketingPush(!marketingPush)}
          />
        </Box>
        <Box className={classes.themeRow}>
          <Typography variant="text-md">
            {t('settings.notifications.reminders')}
          </Typography>
          <AppSwitch
            value={remindersPush}
            onChange={() => setRemindersPush(!remindersPush)}
          />
        </Box>
        <Box>
          <Box className={classes.buttonWrapper}>
            <AppBarWithButtons
              loading={isLoading}
              disabled={!isDirty}
              onCancelClick={allowAndLeave}
            />
          </Box>
        </Box>
      </form>
    </div>
  );
}
